export default __webpack_public_path__ + "static/9-228ffbc06d25529ff03ce71fb50a2437.png";